import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { VideoClipModalComponent } from "./VideoClipModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof VideoClipModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <VideoClipModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const useVideoClipModal = () => useModal(CompassModal);
